import { render } from "./OverviewGeneral.vue?vue&type=template&id=fed0c6bc&scoped=true"
import script from "./OverviewGeneral.vue?vue&type=script&lang=js"
export * from "./OverviewGeneral.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=fed0c6bc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed0c6bc"]])

export default __exports__